export const SkillBar = ({ name, current = 0, target, evidence, max = 5, showTarget = true }) => {
  const pct = Math.min(100, (current / max) * 100);
  const targetPct = target ? Math.min(100, (target / max) * 100) : null;
  const gap = target ? Math.max(0, target - current) : 0;

  return (
    <div data-testid={`skill-bar-${name}`} className="space-y-1.5">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <span className="text-sm text-slate-900 font-medium truncate">{name}</span>
          {evidence && (
            <span className="evidence-chip" title={evidence}>
              kanıt
            </span>
          )}
        </div>
        <div className="flex items-center gap-2 text-xs font-mono">
          <span className="text-slate-700">{current}</span>
          {target ? <span className="text-slate-500">/ <span className="text-amber-600">{target}</span></span> : <span className="text-slate-500">/ {max}</span>}
        </div>
      </div>
      <div className="skill-track relative">
        <div className="skill-fill" style={{ width: `${pct}%` }} />
        {showTarget && targetPct !== null && (
          <div className="skill-target-marker" style={{ left: `${targetPct}%` }} title="Hedef seviye" />
        )}
      </div>
      {evidence && <p className="text-[0.7rem] text-slate-500 leading-snug pt-0.5">{evidence}</p>}
      {gap > 0 && !evidence && (
        <p className="text-[0.7rem] text-amber-600/80">Gap: {gap} seviye</p>
      )}
    </div>
  );
};

export default SkillBar;
